export enum DynamicPages {
    ABOUT = 'about',
    LEGAL_WARNING = 'legal_warning',
    PRIVACITY = 'privacity',
    SELL_CONDITIONS = 'sell_conditions'
  }
  